import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { ErrorBoundary } from "./errors";
import { installDomGuard } from "./errors/domGuard";
import { installStaleChunkReload } from "./errors/staleBuild";

installDomGuard(window.Node.prototype);
installStaleChunkReload(window);

ReactDOM.render(
  <ErrorBoundary section="root">
    <App />
  </ErrorBoundary>,
  document.getElementById("root"),
);
